import McmFloorplanConfig from '~/tenants/mcm/performable/floorplan/McmFloorplanConfig';
import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';
import { DeliverableType } from '~common/model/Deliverable';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { MCM_FLOORPLAN_TIERS } from '~/tenants/mcm/data';

export default class McmFloorplanJob extends McmJob<typeof McmFloorplanConfig> {
  get performable() {
    return McmFloorplanConfig;
  }

  get deliverable() {
    return DeliverableType.FLOORPLAN;
  }

  get media() {
    return PersonaType.PROVIDER;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmFloorplanConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];
    const sqft = this.order.metadata.sqft || 2000;

    // Find the appropriate tier or calculate beyond max tier
    const tier = MCM_FLOORPLAN_TIERS.find(t => sqft <= t.max);
    let price: Big;
    
    if (tier) {
      price = tier.price;
    } else {
      // Beyond max tier, use formula
      const basePrice = new Big('399.95');
      const additionalSqft = Math.max(0, sqft - 12000);
      const additionalCharges = new Big(Math.ceil(additionalSqft / 500)).times(new Big('12.5'));
      price = basePrice.plus(additionalCharges);
    }

    lines.push({
      id: 'floorplan',
      description: 'Floor Plan',
      amount: price,
    });

    return lines;
  }

  get eligible(): boolean {
    return !this.buyer('crossroads') && !this.orderHasPerformable('matterport', { floorplan: true });
  }

  onsite(): number {
    return 30;
  }
}
